import React, { Component } from 'react';
import moment from 'moment';
import Modal from 'react-modal';
import Select from 'react-select';
import { connect } from 'react-redux';
import { Spinner } from 'react-activity';
import DatePicker from 'react-datepicker';
import Headers from '../Header';
import NavigationBar from '../Navigation';
import Loader from '../../common/Loader';
import Pagination from '../../common/Pagination';
import NoAppointmentsFound from '../../common/NoDataFound';
import { getPayoutStatus } from '../../../action/Admin/CommonAction';
import { PATH } from '../../../../utils/Constants';
import { paginationCount } from '../../../../utils/URL';
import { RESPONSE_CONSTANT } from '../../../../utils/ResponseConstant';
import { showNotification } from '../../../action/NotificationAction';
import CustomTableComponent from '../../common/Reports/CustomTableComponent';
import PayoutTableComponent from '../../common/Reports/PayoutTableComponent';
import {
    getFinancialReportPayoutHistory,
    getFinancialReportSessionWise,
    getStripeAccountDetails,
    setupStripConnection,
    educatorFundTransfer,
} from '../../../action/educator/FinancialModuleAction';
import store from '../../../../sessionStorage';
import { customStyles } from '../../../../utils/Utility';
class FinancialReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            institutionId:
                this.props.userDetails.associatedLevels &&
                this.props.userDetails.associatedLevels.length === 1
                    ? this.props.userDetails.associatedLevels[0]
                    : '',
            currentPage: 0,
            startDate: null,
            endDate: null,
            isLoading: false,
            isPageLoading: false,
            todosPerPage: paginationCount,
            CustomerFinancialReportsData: [],
            totalPages: 0,
            fromDate: null,
            toDate: null,
            mobileNav: false,
            getDetails: false,
            type: 'session',
            isStripeAc: false,
            accountDetails: {},
            hasBalance: 0,
            totalamount: 999999999,
            openModal: false,
            payoutLoading: false,
            setupStripLoading: false,
        };
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    // componentDidMount
    componentDidMount() {
        this.getPayoutStatus();
    }

    // Get the payout status
    getPayoutStatus() {
        this.setState({ isPageLoading: true });
        this.props.getPayoutStatus((result) => {
            if (result) {
                if (result.response && result.response.payoutStatus) {
                    this.setState({ showError: false });
                    this.getStripeAccountWithBalance();
                } else {
                    this.setState({ showError: true, isPageLoading: false });
                }
            }
        });
    }

    // stripe status and account balance
    getStripeAccountWithBalance() {
        this.props.getStripeAccountDetails((response) => {
            this.setState({ isPageLoading: false });
            if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                let amount = response.response?.amountNeedsToPaid.split('$');
                this.setState({
                    accountDetails: response.response,
                    hasBalance: amount[1],
                });
            } else {
                this.props.showNotification(response.message, RESPONSE_CONSTANT.ERROR);
                this.setState({ accountDetails: {} });
            }
        });
    }

    // financial report list
    getCustomerFinancialReport(startDate, endDate, pageNumber, itemsPerPage) {
        this.setState({ getDetails: true });
        this.isLoading();
        let fromDate = moment(startDate).format('YYYY-MM-DD');
        let toDate = moment(endDate).format('YYYY-MM-DD');
        let values = {
            pageNumber: pageNumber + 1,
            itemsPerPage,
            institutionId: this.state.institutionId.value,
        };
        this.props.getFinancialReportSessionWise(values, fromDate, toDate, (result) => {
            this.isLoading();
            if (result.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.setState({
                    CustomerFinancialReportsData: result.response.data,
                    totalPages: result.response.totalPages,
                    currentPage: result.response.pageNumber,
                });
            } else {
                this.setState({
                    CustomerFinancialReportsData: [],
                    totalPages: 0,
                    currentPage: 0,
                });
            }
        });
    }

    // financial report list
    getFinancialReportPayoutHistory(startDate, endDate, pageNumber, itemsPerPage) {
        this.setState({ getDetails: true });
        let fromDate = moment(startDate).format('YYYY-MM-DD');
        let toDate = moment(endDate).format('YYYY-MM-DD');
        this.isLoading();
        let values = {
            pageNumber: pageNumber + 1,
            itemsPerPage,
        };
        this.props.getFinancialReportPayoutHistory(values, fromDate, toDate, (result) => {
            this.isLoading();
            if (result.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.setState({
                    CustomerFinancialReportsData: result.response.data,
                    totalPages: result.response.totalPages,
                    currentPage: result.response.pageNumber,
                });
            } else {
                this.setState({
                    CustomerFinancialReportsData: [],
                    totalPages: 0,
                    currentPage: 0,
                });
            }
        });
    }

    // pagination
    handlePageChange(event) {
        if (this.state.type === 'session') {
            this.setState(
                { currentPage: Number(event.selected) },
                this.getCustomerFinancialReport(
                    this.state.fromDate,
                    this.state.toDate,
                    Number(event.selected),
                    this.state.todosPerPage
                )
            );
        } else {
            this.setState(
                { currentPage: Number(event.selected) },
                this.getFinancialReportPayoutHistory(
                    this.state.fromDate,
                    this.state.toDate,
                    Number(event.selected),
                    this.state.todosPerPage
                )
            );
        }
    }

    // clearing Date
    handleFromDateChange = (selectedDate) => {
        this.setState({
            fromDate: selectedDate,
            toDate: null,
            getDetails: false,
        });
    };

    // state change - loading
    isLoading() {
        this.setState({ isLoading: !this.state.isLoading });
    }

    // onClickMobileNav
    onClickMobileNav = (type) => {
        this.setState({ mobileNav: type });
    };

    // setupStripConnection
    setupStripConnection = () => {
        this.setState({ setupStripLoading: true });
        this.props.setupStripConnection((result) => {
            if (result.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.setState({ openModal: true, setupStripLoading: false });
            }
        });
    };

    // fundTransfer
    fundTransfer = () => {
        this.setState({ payoutLoading: true });
        let values = {
            amount: this.state.accountDetails?.amountNeedsToPaid,
        };
        this.props.educatorFundTransfer(values, (result) => {
            this.setState({ payoutLoading: false });
            if (result.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                window.location.reload();
                this.props.showNotification(result.message, RESPONSE_CONSTANT.SUCCESS);
            } else {
                this.props.showNotification(result.message, RESPONSE_CONSTANT.ERROR);
            }
        });
    };

    // setupStripModal
    setupStripModal = () => {
        return (
            <Modal
                isOpen={this.state.openModal}
                overlayClassName={'modal-background z-index-1'}
                className={'modal-width-endcall'}
                ariaHideApp={false}
            >
                <div className="relative w-full max-w-2xl max-h-full">
                    <div className="relative p-6 bg-white rounded-lg shadow">
                        <div>
                            <span className="text-base">
                                A URL has been sent to your Email ID to create the Stripe connect
                                account. Please check your email and proceed with the setup.
                            </span>
                        </div>

                        <div className="flex flex-row items-center justify-end gap-4 mt-6">
                            <button
                                className="w-full py-2 text-base font-semibold text-white rounded-lg bg-primary sm:w-3/12"
                                onClick={() => {
                                    this.setState({ openModal: false });
                                }}
                            >
                                Ok
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    };

    render() {
        const { associatedLevels } = this.props.userDetails;
        let pageDisplayCount = this.state.totalPages;
        return (
            <div className="fixed top-0 left-0 flex w-full h-full">
                <div
                    className={`bg-black bg-opacity-50 fixed top-0 left-0 w-full h-full z-10 ${
                        this.state.mobileNav ? 'block' : 'hidden'
                    }`}
                ></div>
                <NavigationBar
                    nav={true}
                    {...this.props}
                    active={PATH.IM_PHYSICIAN.FINANCIAL_REPORT}
                    mobileNav={this.state.mobileNav}
                    onClickMobileNav={this.onClickMobileNav}
                />
                <main className="flex flex-col flex-grow overflow-hidden">
                    <Headers
                        {...this.props}
                        title="Team Members"
                        onClickMobileNav={this.onClickMobileNav}
                    />
                    <div className="flex flex-col w-full h-full py-8 overflow-auto bg-neutral">
                        <div className="items-center justify-between px-4 sm:flex sm:px-8">
                            <h6 className="m-0 text-lg font-semibold text-black">
                                Financial Reports
                            </h6>
                        </div>
                        {this.state.isPageLoading ? (
                            <Loader />
                        ) : (
                            <>
                                {this.state.showError ? (
                                    <div className="p-6">
                                        <NoAppointmentsFound isText="financialReportsDisabled" />
                                    </div>
                                ) : (
                                    <>
                                        <div className="gap-4 px-4 py-5 sm:flex sm:px-8">
                                            <div className="flex flex-1 p-6 bg-white rounded-lg border-black-10">
                                                <div className="w-full">
                                                    <div className="flex items-center justify-between">
                                                        <p className="mb-1 font-semibold text-black">
                                                            Stripe Account Status
                                                        </p>
                                                        <div className="flex items-center gap-2">
                                                            <button
                                                                className={`${
                                                                    this.state.accountDetails
                                                                        ?.accountCreatedStatus
                                                                        ? 'bg-success'
                                                                        : 'bg-danger'
                                                                } cursor-auto p-3 py-1.5 rounded text-white font-medium whitespace-nowrap text-base sm:mt-0 mt-4`}
                                                            >
                                                                {this.state.accountDetails
                                                                    ?.accountCreatedStatus
                                                                    ? 'Active'
                                                                    : 'Inactive'}
                                                            </button>
                                                            {!this.state.accountDetails
                                                                ?.accountCreatedStatus && (
                                                                <button
                                                                    className={`bg-primary p-3 py-1.5 rounded text-white font-medium whitespace-nowrap text-base sm:mt-0 mt-4 ${
                                                                        this.state.setupStripLoading
                                                                            ? 'disabled-button'
                                                                            : ''
                                                                    }`}
                                                                    onClick={() =>
                                                                        this.setupStripConnection()
                                                                    }
                                                                    disabled={
                                                                        this.state.setupStripLoading
                                                                    }
                                                                >
                                                                    <div
                                                                        style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent:
                                                                                'center',
                                                                        }}
                                                                    >
                                                                        {this.state
                                                                            .setupStripLoading ? (
                                                                            <Spinner color="#FFF" />
                                                                        ) : (
                                                                            'Setup'
                                                                        )}
                                                                    </div>
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex flex-1 p-6 mt-5 bg-white rounded-lg border-black-10 sm:mt-0">
                                                <div className="w-full">
                                                    <div className="flex items-center justify-between">
                                                        <p className="mb-1 font-semibold text-black">
                                                            Available Balance:
                                                            {
                                                                this.state.accountDetails
                                                                    ?.amountNeedsToPaid
                                                            }
                                                        </p>
                                                        <div className="flex justify-end">
                                                            <button
                                                                onClick={() => this.fundTransfer()}
                                                                className={`bg-primary p-3 py-1.5 rounded text-white font-medium whitespace-nowrap text-base sm:mt-0 mt-4 ${
                                                                    parseFloat(
                                                                        this.state.hasBalance
                                                                    ) <= 0 ||
                                                                    !this.state.accountDetails
                                                                        .accountCreatedStatus ||
                                                                    this.state.payoutLoading
                                                                        ? 'disabled-button'
                                                                        : ''
                                                                }`}
                                                                disabled={
                                                                    parseFloat(
                                                                        this.state.hasBalance
                                                                    ) <= 0 ||
                                                                    !this.state.accountDetails
                                                                        .accountCreatedStatus ||
                                                                    this.state.payoutLoading
                                                                }
                                                            >
                                                                <div
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                    }}
                                                                >
                                                                    {this.state.payoutLoading ? (
                                                                        <Spinner color="#FFF" />
                                                                    ) : (
                                                                        'Payout'
                                                                    )}
                                                                </div>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="gap-4 px-4 py-5 mt-2 sm:flex sm:px-8 sm:mt-0 lg:w-2/8">
                                            {/* date picker */}
                                            <div className="relative flex-wrap items-stretch w-full mb-0 sm:flex">
                                                <div className="flex w-full mt-2 mb-0 bg-white rounded border-black-10 sm:mt-0">
                                                    <div className="grow">
                                                        <DatePicker
                                                            name="fromDate"
                                                            className="w-full px-2 text-base leading-normal text-black placeholder:text-secondary example-custom-input"
                                                            wrapperClassName="w-full"
                                                            placeholderText="From date"
                                                            maxDate={new Date()}
                                                            selected={
                                                                (this.state.fromDate &&
                                                                    new Date(
                                                                        this.state.fromDate
                                                                    )) ||
                                                                null
                                                            }
                                                            onChange={this.handleFromDateChange}
                                                            dropdownMode="select"
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            yearDropdownItemNumber={80}
                                                            scrollableYearDropdown
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="relative flex-wrap items-stretch w-full mb-0 sm:flex">
                                                <div className="flex w-full mt-2 mb-0 bg-white rounded border-black-10 sm:mt-0">
                                                    <div className="grow">
                                                        <DatePicker
                                                            name="toDate"
                                                            className="w-full px-2 text-base leading-normal text-black placeholder:text-secondary example-custom-input"
                                                            wrapperClassName="w-full"
                                                            placeholderText="To date"
                                                            selected={this.state.toDate}
                                                            onChange={(selectedDate) =>
                                                                this.setState({
                                                                    toDate: selectedDate,
                                                                })
                                                            }
                                                            minDate={this.state.fromDate}
                                                            maxDate={new Date()}
                                                            dropdownMode="select"
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            yearDropdownItemNumber={80}
                                                            scrollableYearDropdown
                                                            autoComplete="off"
                                                            disabled={!this.state.fromDate}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex w-full mt-2 mb-0 bg-white rounded border-black-10 sm:mt-0">
                                                <select
                                                    className="w-full border border-black-10 bg-white text-black font-normal text-base rounded block py-1.5 px-2"
                                                    style={{ cursor: 'pointer' }}
                                                    onChange={(e) =>
                                                        this.setState({
                                                            type: e.target.value,
                                                            getDetails: false,
                                                        })
                                                    }
                                                >
                                                    <option value="session">Session Report</option>
                                                    <option value="payout">Payout History</option>
                                                </select>
                                            </div>
                                            {this.state.type === 'session' && (
                                                <div className="flex w-full mt-2 mb-0 bg-white rounded border-black-10 sm:mt-0">
                                                    <Select
                                                        id="level"
                                                        name="level"
                                                        onChange={(event) => {
                                                            this.setState({
                                                                institutionId: event,
                                                                subjectId: '',
                                                            });
                                                        }}
                                                        value={this.state.institutionId}
                                                        ref={(r) => (this.LevelRef = r)}
                                                        className="block w-full rounded text-secondary text-md border-black-10 whitespace-nowrap"
                                                        options={
                                                            associatedLevels &&
                                                            associatedLevels.length &&
                                                            associatedLevels
                                                        }
                                                        styles={customStyles}
                                                        isSearchable={true}
                                                        placeholder="Select any level"
                                                        onKeyDown={(event) => {
                                                            const key = event.key;
                                                            const allowedCharacters =
                                                                /^[a-zA-Z0-9\s]+$/;
                                                            if (
                                                                !allowedCharacters.test(key) ||
                                                                (event.keyCode === 32 &&
                                                                    !this.LevelRef.state.inputValue)
                                                            ) {
                                                                event.preventDefault();
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            )}
                                            {/* go btn */}
                                            <div className="flex items-end justify-end">
                                                <button
                                                    className={`bg-primary p-3 py-2 rounded-lg text-white font-semibold whitespace-nowrap text-base sm:mt-0 mt-4 ${
                                                        !(
                                                            (this.state.type === 'session' &&
                                                                this.state.fromDate &&
                                                                this.state.toDate &&
                                                                this.state.institutionId) ||
                                                            (this.state.type !== 'session' &&
                                                                this.state.fromDate &&
                                                                this.state.toDate)
                                                        )
                                                            ? 'disabled-button'
                                                            : ''
                                                    }`}
                                                    disabled={
                                                        !(
                                                            (this.state.type === 'session' &&
                                                                this.state.fromDate &&
                                                                this.state.toDate &&
                                                                this.state.institutionId) ||
                                                            (this.state.type !== 'session' &&
                                                                this.state.fromDate &&
                                                                this.state.toDate)
                                                        )
                                                    }
                                                    onClick={() => {
                                                        // list api need to be integrated
                                                        if (this.state.type === 'session') {
                                                            this.getCustomerFinancialReport(
                                                                this.state.fromDate,
                                                                this.state.toDate,
                                                                this.state.currentPage,
                                                                this.state.todosPerPage
                                                            );
                                                        } else {
                                                            this.getFinancialReportPayoutHistory(
                                                                this.state.fromDate,
                                                                this.state.toDate,
                                                                this.state.currentPage,
                                                                this.state.todosPerPage
                                                            );
                                                        }
                                                    }}
                                                >
                                                    Go
                                                </button>
                                            </div>
                                        </div>
                                        {this.state.isLoading ? (
                                            <Loader />
                                        ) : (
                                            <div className="flex flex-col gap-4 px-4 pt-6 sm:px-8">
                                                {this.state.getDetails ? (
                                                    <>
                                                        {this.state.type === 'session' && (
                                                            <p className="flex justify-end text-sm font-normal text-muted">
                                                                Click on the “Note Pending” status,
                                                                To complete the notes for the “Note
                                                                Pending” sessions.
                                                            </p>
                                                        )}
                                                        <div className="w-full overflow-x-auto bg-white rounded-lg border-black-10">
                                                            {/* table component */}
                                                            {this.state.type === 'session' ? (
                                                                <CustomTableComponent
                                                                    {...this.state}
                                                                    CustomerFinancialReportsData={
                                                                        this.state
                                                                            .CustomerFinancialReportsData
                                                                    }
                                                                    data={store.get('userSession')}
                                                                    userId={
                                                                        this.props.match.params
                                                                            .userId
                                                                    }
                                                                />
                                                            ) : (
                                                                <PayoutTableComponent
                                                                    {...this.state}
                                                                    CustomerFinancialReportsData={
                                                                        this.state
                                                                            .CustomerFinancialReportsData
                                                                    }
                                                                />
                                                            )}
                                                        </div>
                                                        {this.state.CustomerFinancialReportsData
                                                            .length > 0 && (
                                                            <div className="flex items-center justify-end gap-2 mt-4 -space-x-px">
                                                                {pageDisplayCount > 1 && (
                                                                    <Pagination
                                                                        currentPage={
                                                                            this.state.currentPage
                                                                        }
                                                                        pageDisplayCount={
                                                                            pageDisplayCount
                                                                        }
                                                                        onPageChange={
                                                                            this.handlePageChange
                                                                        }
                                                                    />
                                                                )}
                                                            </div>
                                                        )}
                                                    </>
                                                ) : (
                                                    <div className="p-6">
                                                        <NoAppointmentsFound isText="pleaseSelectDateForReport" />
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </>
                                )}
                            </>
                        )}
                    </div>
                </main>
                {this.setupStripModal()}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.UserReducer.userDetails,
    };
};

const mapDispatchtoProps = (dispatch) => {
    return {
        getPayoutStatus: (callback) => {
            dispatch(getPayoutStatus(callback));
        },
        getStripeAccountDetails: (callback) => {
            dispatch(getStripeAccountDetails(callback));
        },
        getFinancialReportSessionWise: (values, fromDate, toDate, callback) => {
            dispatch(getFinancialReportSessionWise(values, fromDate, toDate, callback));
        },
        getFinancialReportPayoutHistory: (values, fromDate, toDate, callback) => {
            dispatch(getFinancialReportPayoutHistory(values, fromDate, toDate, callback));
        },
        setupStripConnection: (callback) => {
            dispatch(setupStripConnection(callback));
        },
        educatorFundTransfer: (values, callback) => {
            dispatch(educatorFundTransfer(values, callback));
        },
        showNotification: (message, type) => {
            dispatch(showNotification(message, type));
        },
    };
};

export default connect(mapStateToProps, mapDispatchtoProps)(FinancialReport);
